import { FormEvent, useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { api } from "../../api/client";
import { AlertBanner } from "../../components/feedback/AlertBanner";
import { AuthLayout } from "../../components/layout/AuthLayout";
import { Field } from "../../components/forms/Field";
import { authTokenFromHash } from "../../lib/authTokenFromHash";
import { apiError } from "../../lib/apiError";

export function ResetPasswordPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const tokenFromQuery = params.get("token")?.trim() || "";
  const initialToken = tokenFromQuery || authTokenFromHash();
  const [token, setToken] = useState(initialToken);
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [error, setError] = useState<string | null>(
    initialToken
      ? null
      : "Brak tokenu resetu hasła. Użyj linku z wiadomości e-mail.",
  );
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!navigator.onLine) {
      return;
    }
    void api.GET("/api/auth/config");
    const hashToken = authTokenFromHash();
    if (hashToken) {
      setToken(hashToken);
      setError(null);
    }
  }, []);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    if (!token) {
      setError("Brak tokenu resetu hasła. Użyj linku z wiadomości e-mail.");
      return;
    }
    setBusy(true);
    setError(null);
    const result = await api.POST("/api/auth/reset-password", {
      body: {
        token,
        password,
        password_confirm: passwordConfirm,
      },
    });
    setBusy(false);
    if (result.error) {
      setError(apiError(result.error, "Nie udało się zmienić hasła."));
      return;
    }
    navigate("/login?reset=1", { replace: true });
  }

  return (
    <AuthLayout
      title="Nowe hasło"
      subtitle="Ustaw nowe hasło do konta"
    >
      <AlertBanner variant="error" message={error} onDismiss={() => setError(null)} />
      <form
        className="auth__form"
        data-testid="reset-password-form"
        autoComplete="off"
        onSubmit={(event) => void onSubmit(event)}
      >
        <Field label="Nowe hasło">
          <input
            id="password"
            className="input"
            type="password"
            name="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
            minLength={8}
            autoFocus
            autoComplete="new-password"
            data-testid="reset-password"
          />
          <span className="field__hint">Minimum 8 znaków</span>
        </Field>
        <Field label="Powtórz hasło">
          <input
            id="password_confirm"
            className="input"
            type="password"
            name="password_confirm"
            value={passwordConfirm}
            onChange={(event) => setPasswordConfirm(event.target.value)}
            required
            minLength={8}
            autoComplete="new-password"
            data-testid="reset-password-confirm"
          />
        </Field>
        <button
          className="btn btn--block"
          type="submit"
          disabled={busy || !token}
          data-testid="reset-submit"
        >
          Zapisz nowe hasło
        </button>
      </form>
      <p className="auth__footer">
        <Link to="/login">Wróć do logowania</Link>
      </p>
    </AuthLayout>
  );
}
